import { useEffect } from "react"
import Select from "react-select"
import { Form, Row, Col, Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useSelector, useDispatch } from "react-redux"
import { getForSelect as getAnimalsForSelect } from '../../../actions/other/animalsActions'

export default function EventFormSemental({ type, state, handleInputChange, submit, isRegistering, isAddingOrEditing }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const { animalsForSelect } = useSelector(state => state.animals)

	useEffect(() => {
		dispatch(getAnimalsForSelect())
	}, [dispatch])

	const animals = animalsForSelect?.map(a => ({ value: a._id, label: a.identifier, category: a.category }))
	const sementales = animals?.filter(a => a.category === 'semental')

	return (
		<Form onSubmit={submit} className="formulario">
			<h1 className="mb-4">{t('menus.event_semental')}</h1>

			<Row className="my-2">
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.entryDate')}</Form.Label>
						<Form.Control
							type="date"
							name="entryDate"
							value={state.entryDate || ''}
							onChange={handleInputChange}
							required
						/>
					</Form.Group>
				</Col>

				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.exitDate')}</Form.Label>
						<Form.Control
							type="date"
							name="exitDate"
							value={state.exitDate || ''}
							onChange={handleInputChange}
						/>
					</Form.Group>
				</Col>
			</Row>

			<Row className="my-2">
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.semental')}</Form.Label>
						<Select
							options={sementales}
							value={sementales.find(opt => opt.value === state.semental) || null}
							onChange={opt => handleInputChange({ target: { name: 'semental', value: opt.value } })}
						/>
					</Form.Group>
				</Col>
			</Row>

			<Row className="mt-4">
				<Col>
					<Button type="submit" className="w-100" variant="primary">
						{isRegistering
							? <span className="spinner-border spinner-border-sm" />
							: isAddingOrEditing === 'editing'
								? t('admin.animal.edit')
								: t('admin.animal.register')
						}
					</Button>
				</Col>
			</Row>
		</Form>
	)
}
